import { render, staticRenderFns } from "./DataPrivacy.vue?vue&type=template&id=67a93702&scoped=true&"
import script from "./DataPrivacy.vue?vue&type=script&lang=js&"
export * from "./DataPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./DataPrivacy.vue?vue&type=style&index=0&id=67a93702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a93702",
  null
  
)

export default component.exports